export default __webpack_public_path__ + "static/accordianTabsBg-920a637905a133e74271f130bc5e5752.png";